import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import uil from './assets/script/js.js'
import request from './networks/request.js'
import moment from 'moment'
Vue.config.productionTip = false
Vue.prototype.$request = request;
Vue.prototype.$uil = uil;
Vue.prototype.$moment=moment
new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app')
